import React from "react";

const Footer = () => {
  return (
    <div className="text-white ml-[5vw] mr-[5vw] text-center  uppercase font-face-n text-xs mt-6">
      Made by Shreyas with ❤️, React and Sanity.
    </div>
  );
};

export default Footer;
